import styled from '@emotion/styled';
import { fontSizes } from '../../../app/typography';
import { gray } from '@kizen/kds/Colors';

export default styled.input`
  flex: 1;
  font-size: ${fontSizes.text};
  letter-spacing: -0.00125em;
  color: ${gray['gray-800']};
  background-color: transparent; // No default grey when disabled
  outline: none;
  border: none;
  padding: 0;
  &::placeholder {
    color: ${gray['gray-600']};
  }
`;
